"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isActive,
      "has-modal-card": "",
      "trap-focus": "",
      width: 420,
      "aria-role": "dialog",
      "aria-modal": ""
    },
    on: {
      close: _vm.handleClose
    }
  }, [_c("div", {
    staticClass: "modal-card user-tag-modal"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        Identificação do usuário\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      click: _vm.handleClose
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_vm.isLoading ? _c("div", {
    staticClass: "user-tag-content"
  }, [_c("b-loading", {
    attrs: {
      "is-full-page": false
    }
  }), _vm._v(" "), _c("p", [_vm._v("Carregando identificação... (" + _vm._s(_vm.remainingSeconds) + "s)")])], 1) : _vm.status === 202 ? _c("div", {
    staticClass: "user-tag-content"
  }, [_c("p", [_vm._v("Carregando identificação... (" + _vm._s(_vm.remainingSeconds) + "s)")])]) : _vm.status === 200 && _vm.url ? _c("div", {
    staticClass: "user-tag-content"
  }, [_c("img", {
    staticClass: "user-tag-image",
    attrs: {
      src: _vm.url,
      alt: "QR Code"
    }
  })]) : _c("div", {
    staticClass: "user-tag-content"
  }, [_c("p", [_vm._v("Não foi possível carregar a identificação.")]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-text"
    },
    on: {
      click: _vm.retryFlow
    }
  }, [_vm._v("\n          Tentar novamente\n        ")])], 1)]), _vm._v(" "), _vm.status === 200 && _vm.url ? _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      expanded: ""
    },
    on: {
      click: _vm.downloadTag
    }
  }, [_vm._v("\n        Baixar\n      ")])], 1) : _vm._e()])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;